import React, { Suspense } from 'react';
import { Navigate } from "react-router-dom";

import LoadingSpinner from '@components/loading-spinner/LoadingSpinner';
import LazyLoadable from '@helpers/LazyLoadable';
import { lazy } from '@loadable/component';
import { ARCHEM_APPS } from '@src/app/pages/home/ArchemApps';
import ProtectedRoute from '@src/app/routes/ProtectedRoute';

const DashboardSummaryCard = LazyLoadable(lazy(() => import("./DashboardSummary/DashboardSummaryCard")))
const CustomerDeliveryCard = LazyLoadable(lazy(() => import("./customer-delivery/card/CustomerDeliveryCard")));
const DeliveryRecords = LazyLoadable(lazy(() => import("./delivery-records/DeliveryRecordsList")));
const MaintenanceCustomers = LazyLoadable(lazy(() => import("./maintenance/customers/card/MaintenanceCustomerCard")));
const InterplantTransferCard = LazyLoadable(lazy(() => import("./interplant-transfer/InterPlantTransferCard")));
// const SupplierMonitoringCard = LazyLoadable(lazy(() => import("./supplier-monitoring/card/SupplierMonitoringCard")));
const ManualAdjustmentCard = LazyLoadable(lazy(() => import("./manual-adjustments/ManualAdjustments")));

const SealCard = LazyLoadable(lazy(() => import("./maintenance/seals/SealCard")))
const SealUsageReportCard = LazyLoadable(lazy(() => import("./reports/seal-usage/SealUsageReport")))
const ReceivingReportCard = LazyLoadable(lazy(() => import("./ReceivingReport/ReceivingReportCard")))
// const DNDRReport = LazyLoadable(lazy(() => import('./dn-dr-report/DnDrReport'));
const WeightScaleReport = LazyLoadable(lazy(() => import('./reports/weight-scale/WeightScaleCard')))
const WeighingReport = LazyLoadable(lazy(() => import('./reports/weighing-report/WeighingReport')))
const TradingReport = LazyLoadable(lazy(() => import('./reports/trading-report/TradingReportCard')))
const TruckingRatesCard = LazyLoadable(lazy(() => import('./maintenance/trucking-rates/TruckingRatesCard')))
const TruckingRatesCardOLD = LazyLoadable(lazy(() => import("./maintenance/hauler-rates/card/HaulerRatesCard")))
const AtwTask = LazyLoadable(lazy(() => import('./maintenance/atw-task/AtwTask')));
const AtlTask = LazyLoadable(lazy(() => import('./maintenance/atl-task/AtlTask')));
const SupplierMonitoring = LazyLoadable(lazy(() => import("./atl-supplier-monitoring/SupplierMonitoringCard")));
const ATLDialog = LazyLoadable(lazy(() => import('./atl-supplier-monitoring/atl-dialog/ATLDialog')));
const TradingAtwAtlLinkDialog = LazyLoadable(lazy(() => import('./reports/trading-report/dialog/AtwAtlLinkDialog')))
const TruckingRatesDialog = LazyLoadable(lazy(() => import('./maintenance/trucking-rates/dialog/TruckingRatesDialog')))
const DnDrReport = LazyLoadable(lazy(() => import('./dn-dr-report/DnDrReport')))
const CustomerDeliveryDialog = LazyLoadable(lazy(() => import('./customer-delivery/dialog/CustomerDeliveryDialog')))
const SealDialog = LazyLoadable(lazy(() => import('./maintenance/seals/dialog/SealDialog')));
const MaintenanceCustomerDialog = LazyLoadable(lazy(() => import('./maintenance/customers/dialog/MaintenanceCustomerDialog')));
const InterPlantDialog = LazyLoadable(lazy(() => import('./interplant-transfer/dialog/InterPlantDialog')));
const ManualAdjustmentDialog = LazyLoadable(lazy(() => import('./manual-adjustments/dialog/ManualAdjustmentDialog')));
const HaulerTypes = LazyLoadable(lazy(() => import('./maintenance/hauler-type')))
const HaulerBilling = LazyLoadable(lazy(() => import('./hauler-billing')))

export const ROUTES_LOGISTICS = [
  {
    path: "/logistics",
    element: <Suspense fallback={<LoadingSpinner />}> <ProtectedRoute module_name={ARCHEM_APPS.LOGISTICS.module_name} /> </Suspense>,
    children: [
      {
        index: true,
        element: <Navigate to="dashboard" />,
      },
      {
        path: "dashboard",
        element: <DashboardSummaryCard />,
        children: [
          {
            path: 'customerdelivery',
            element: <CustomerDeliveryCard />
          }
        ]
      },
      {
        path: "deliveryrecords",
        element: <DeliveryRecords />
      },
      {
        path: "reports/trading/*",
        element: <TradingReport />,
        children: [
          {
            path: 'new/:cdid',
            element: <TradingAtwAtlLinkDialog />
          }
        ]
      },
      {
        path: "reports/sealusage",
        element: <SealUsageReportCard />
      },
      {
        path: 'reports/dndr',
        element: <DnDrReport />
      },
      {
        path: 'reports/weighing',
        element: <WeighingReport />
      },
      {
        path: 'reports/receivingreport',
        element: <ReceivingReportCard />
      },
      {
        path: 'reports/weightscale',
        element: <WeightScaleReport />
      },
      {
        path: "customerdelivery/*",
        element: <CustomerDeliveryCard />,
        children: [
          {
            path: 'new/*',
            element: <CustomerDeliveryDialog show={true} />
          },
          {
            path: ':id/:eid/edit/:soid/:cid',
            element: <CustomerDeliveryDialog show={true} />
          }
        ]
      },
      {
        path: 'haulbilling',
        element: <HaulerBilling />
      },
      {
        path: 'maintenance/*',
        children: [
          {
            path: 'haulertypes',
            element: <HaulerTypes />
          },
          {
            path: 'atwtasks',
            element: <AtwTask />,
          },
          {
            path: 'atltasks',
            element: <AtlTask />,
          },
          {
            path: 'customers/*',
            element: <MaintenanceCustomers />,
            children: [
              {
                path: 'new',
                element: <MaintenanceCustomerDialog show />
              },
              {
                path: ':customer_id',
                element: <MaintenanceCustomerDialog show />
              }
            ]
          },
          {
            path: 'seal/*',
            element: <SealCard />,
            children: [
              {
                path: 'new',
                element: <SealDialog />
              },
              {
                path: ':id',
                element: <SealDialog />
              }
            ]
          },
          {
            path: 'truckingrates/*',
            element: <TruckingRatesCard />,
            children: [
              {
                path: 'new',
                element: <TruckingRatesDialog />
              },
              {
                path: ':uuid',
                element: <TruckingRatesDialog />
              }
            ]
          },
          {
            path: 'truckingratesold/*',
            element: <TruckingRatesCardOLD />,
            children: [
              {
                path: 'new',
                element: <SealDialog />
              },
              {
                path: ':id',
                element: <SealDialog />
              }
            ]
          }
        ]
      },
      {
        path: 'interplanttransfers/*',
        element: <InterplantTransferCard />,
        children: [
          {
            path: "newtransfer",
            element: <InterPlantDialog show />
          },
          {
            path: ":uuid",
            element: <InterPlantDialog show />
          }
        ]
      },
      {
        path: 'suppliermonitoring/*',
        element: <SupplierMonitoring />,
        children: [
          {
            path: "new",
            element: <ATLDialog />
          },
          {
            path: ":atl_id",
            element: <ATLDialog />
          }
        ]
      },
      {
        path: 'manualadjustments/*',
        element: <ManualAdjustmentCard />,
        children: [
          {
            path: "newadjustment/:adjustment_type",
            element: <ManualAdjustmentDialog show />
          },
          // {
          //   path: "edit/:adjustment_type/:uuid/:contract/:qty",
          //   element: <ManualAdjustmentDialog show />
          // }
        ]
      }
    ]
  },


];
